import React, { useState } from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

import { Icons } from '../../Themes';
import { Providers } from '../../Utils/Types';
import { getGoogleClientId } from '../../Utils/OAuth';
import CustomIcon from '../DesignSystem/CustomIcon';
import useCookieSettings from '../../Hooks/useCookieSettings';
import useSpace from '../../Hooks/useSpace';
import AuthCookieModal from './AuthCookieModal';
import AuthenticationButton from './Button';

const Button = ({ ...props }: any) => (
  <AuthenticationButton
    // we pass an invalid colour to keep the ones in the svg
    startIcon={<CustomIcon src={Icons.misc.googleLoginIcon} size={24} color="x" />}
    provider="Google"
    {...props}
  >
    Google
  </AuthenticationButton>
);

const GoogleLoginButton = ({ handleLogin }: any) => {
  const login = useGoogleLogin({
    onSuccess: handleLogin,
    flow: 'auth-code',
  });

  return <Button onClick={login} />;
};

function GoogleButton({ onClick }: any) {
  const { space } = useSpace();
  const { settings } = useCookieSettings();
  const [cookieModalOpen, setCookieModalOpen] = useState(false);
  const googleClientId = getGoogleClientId(space);
  const cookieEnabled = settings.google;

  if (!googleClientId) {
    return null;
  }

  const handleLogin = (payload: any) => {
    onClick(Providers.PROVIDER_NAME_GOOGLE, payload);
  };

  return (
    <>
      {cookieEnabled ? (
        <GoogleOAuthProvider clientId={googleClientId}>
          <GoogleLoginButton handleLogin={handleLogin} />
        </GoogleOAuthProvider>
      ) : (
        <Button onClick={() => setCookieModalOpen(true)} />
      )}
      <AuthCookieModal provider="google" open={cookieModalOpen} setOpen={setCookieModalOpen} />
    </>
  );
}

export default GoogleButton;
